import { render, staticRenderFns } from "./plan-table.vue?vue&type=template&id=33069880&"
import script from "./plan-table.vue?vue&type=script&lang=js&"
export * from "./plan-table.vue?vue&type=script&lang=js&"
import style0 from "./plan-table.vue?vue&type=style&index=0&id=33069880&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports